import React, { Component } from 'react';
import loadScripts from '../../dassets/js/custom';
import { Link } from 'react-router-dom';

class Home extends Component {
  componentDidMount() {
    loadScripts();
  }
  render() {
    return (
      <>
        {/* <!--=================================
    Banner --> */}

        <section className="slider-03 pb-4">
          <div id="main-slider" className="swiper-container">
            <div className="swiper-wrapper">
              <div className="swiper-slide slide-03"
                style={{ backgroundImage: `url("${require('../../dassets/images/slider/home-03/03.jpg')}")`, backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}>
                <div className="container h-75">
                  <div className="row d-flex h-75 justify-content-center">
                    <div className="col-lg-8 col-md-10 col-sm-12 text-center align-self-center">
                      <div className="banner-content">
                        <img className="img-fluid" data-swiper-animation="zoomIn" data-duration="2.0s" data-delay="0.2s"
                          src={require("../../dassets/images/slider/home-03/03.png")} alt="#" />
                        <div className="content">
                          <h6 className="text-white mb-0 lead fw-bold" data-swiper-animation="fadeInDown" data-duration="2.0s"
                            data-delay="0.4s">Expert and Professional Advice.</h6>
                          <h2 className="animated mb-0 text-white h1" data-swiper-animation="fadeInDown" data-duration="2.0s"
                            data-delay="0.6s">Financial Advisory Services</h2>
                            <Link className="animated btn btn-light mt-3" data-swiper-animation="fadeInUp" data-duration="2.0s" data-delay="0.8s" to={"/services/financial-advisory"}>Learn more</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="swiper-slide slide-01"
                style={{ backgroundImage: `url("${require('../../dassets/images/slider/home-03/01.jpg')}")`, backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}>
                <div className="container h-75">
                  <div className="row d-flex h-75 justify-content-center">
                    <div className="col-lg-8 col-md-10 col-sm-12 text-center align-self-center">
                      <div className="banner-content">
                        <img className="img-fluid" data-swiper-animation="zoomIn" data-duration="2.0s" data-delay="0.2s"
                          src={require("../../dassets/images/slider/home-03/03.png")} alt="#" />
                        <div className="content">
                          <h6 className="text-white mb-0 lead fw-bold" data-swiper-animation="fadeInDown" data-duration="2.0s"
                            data-delay="0.4s">Access your account anywhere, anytime.</h6>
                          <h2 className="animated mb-0 text-white h1" data-swiper-animation="fadeInDown" data-duration="2.0s"
                            data-delay="0.6s">Online Trading</h2>
                            <Link className="animated btn btn-light mt-3" data-swiper-animation="fadeInUp" data-duration="2.0s" data-delay="0.8s" to={"/services/stockbroking"}>Learn more</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="swiper-slide slide-02"
                style={{ backgroundImage: `url("${require('../../dassets/images/slider/home-03/02.jpg')}")`, backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}>
                <div className="container h-75">
                  <div className="row d-flex h-75 justify-content-center">
                    <div className="col-lg-8 col-md-10 col-sm-12 text-center align-self-center">
                      <div className="banner-content">
                        <img className="img-fluid" data-swiper-animation="zoomIn" data-duration="2.0s" data-delay="0.2s"
                          src={require("../../dassets/images/slider/home-03/03.png")} alt="#" />
                        <div className="content">
                          <h6 className="text-white mb-0 lead fw-bold" data-swiper-animation="fadeInDown" data-duration="2.0s"
                            data-delay="0.4s">We help you manage your funds.</h6>
                          <h2 className="animated mb-0 text-white h1" data-swiper-animation="fadeInDown" data-duration="2.0s"
                            data-delay="0.6s">Fund Management</h2>
                            <Link className="animated btn btn-light mt-3" data-swiper-animation="fadeInUp" data-duration="2.0s" data-delay="0.8s" to={"/services/fund-management"}>Learn more</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <!-- Pagination --> */}
            <div className="swiper-button-prev" tabIndex="0" role="button" aria-label="Previous slide"><i className="fa fa-angle-left" aria-hidden="true"></i> </div>
            <div className="swiper-button-next" tabIndex="0" role="button" aria-label="Next slide"><i className="fa fa-angle-right" aria-hidden="true"></i></div>

          </div>
        </section>
        {/* <!--=================================
    Banner --> */}

        {/* =================================
    Agency */}
        <section className="pt-4 pb-4">
          <div className="container">
            <div className="row d-flex align-content-center flex-wrap">
              <div className="col-md-12 align-self-center ps-3 ps-lg-5">
                <div className="row">
                  <div className="col-12">
                    <div className="nav mb-4 nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                      <a className="nav-link active" id="v-pills-who-we-are-tab" data-bs-toggle="pill" href="#v-pills-who-we-are" role="tab" aria-controls="v-pills-who-we-are" aria-selected="true">Who we are</a>
                      <a className="nav-link" id="v-pills-our-vision-tab" data-bs-toggle="pill" href="#v-pills-our-vision" role="tab" aria-controls="v-pills-our-vision" aria-selected="false">Our vision</a>
                      <a className="nav-link" id="v-pills-our-mission-tab" data-bs-toggle="pill" href="#v-pills-our-mission" role="tab" aria-controls="v-pills-our-mission" aria-selected="false">Our mission</a>
                      <a className="nav-link" id="v-pills-our-history-tab" data-bs-toggle="pill" href="#v-pills-our-history" role="tab" aria-controls="v-pills-our-history" aria-selected="false">Our philosophy</a>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="tab-content" id="v-pills-tabContent">
                      <div className="tab-pane fade show active" id="v-pills-who-we-are" role="tabpanel" aria-labelledby="v-pills-who-we-are-tab">
                        <div className="row">
                          <div className="col-lg-12 mb-lg-0 mb-4">
                            <h4 className="mb-3">Our Company Has Gained Trust Over The Past <span>29+</span> Years</h4>
                            <p>Dynamic Portfolio Limited ("Dynamic" or "the Company") was incorporated on 8th June, 1993 as a private limited liability company with the objective of providing world class investment advisory services which are tailor made to meet the specific needs of our local and international clients.</p>
                            <p className="mb-4">Accordingly, the company is registered and regulated by the Securities & Exchange Commission (SEC) and The Nigerian Exchange Group as Issuing House and Broker/Dealer.  Our current authorized share capital and net assets is in excess of N1.0 billion.</p>
                            <div className="row">
                              <div className="col-lg-6 col-md-6 mb-md-5 mb-4">
                                <div className="feature-info feature-info-style-3">
                                  <div className="feature-info-icon">
                                    <i className="flaticon-shield"></i>
                                  </div>
                                  <div className="feature-info-content">
                                    <h6 className="feature-info-title">Trusted and Secured</h6>
                                    <p>Our clients trust us because their funds and information are secured with us.</p>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6 mb-md-5 mb-4">
                                <div className="feature-info feature-info-style-3">
                                  <div className="feature-info-icon">
                                    <i className="flaticon-money"></i>
                                  </div>
                                  <div className="feature-info-content">
                                    <h6 className="feature-info-title">Fund Management</h6>
                                    <p>We actively help you to grow and manage your funds.</p>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6 mb-md-5 mb-4">
                                <div className="feature-info feature-info-style-3">
                                  <div className="feature-info-icon">
                                    <i className="flaticon-telemarketer"></i>
                                  </div>
                                  <div className="feature-info-content">
                                    <h6 className="feature-info-title">Continuous Support</h6>
                                    <p>We provide necessary support for all our customers</p>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6 mb-md-0 mb-4">
                                <div className="feature-info feature-info-style-3">
                                  <div className="feature-info-icon">
                                    <i className="flaticon-team"></i>
                                  </div>
                                  <div className="feature-info-content">
                                    <h6 className="feature-info-title">100% Clients' Satisfaction</h6>
                                    <p>Our testimonials show how satisfied our clients are with our services.</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <Link className="btn btn-link text-dark" to={"about"}>Learn more about us <i className="fas fa-arrow-right ms-1"></i></Link>
                          </div>
                        </div>
                      </div>
                      <div className="tab-pane fade" id="v-pills-our-vision" role="tabpanel" aria-labelledby="v-pills-our-vision-tab">
                        <h6 className="mb-3">Our Vision </h6>
                        <p>To be the foremost Investment Banking Services Firm, providing unequaled services and satisfaction to our select clientele.</p>
                        <Link className="btn btn-link text-dark" to={"/about"}>Learn more about us <i className="fas fa-arrow-right ms-1"></i></Link>
                      </div>
                      <div className="tab-pane fade" id="v-pills-our-mission" role="tabpanel" aria-labelledby="v-pills-our-mission-tab">
                        <h6 className="mb-3">Our Mission </h6>
                        <p>Given the fact that we are committed to the provision of satisfactory services to our clients with all the necessary resources around us, we aspire to be the leading capital market services provider with high quality service delivery to our select clientele.</p>
                        <Link className="btn btn-link text-dark" to={"/about"}>Learn more about us <i className="fas fa-arrow-right ms-1"></i></Link>
                      </div>
                      <div className="tab-pane fade" id="v-pills-our-history" role="tabpanel" aria-labelledby="v-pills-our-history-tab">
                        <h6 className="mb-3">Our Philosophy </h6>
                        <p>We believe that we can only afford to go to sleep, if our clients' needs are met and satisfaction are obvious. Always, we place ourselves in the clients' position expecting to get the same quality of services that we provide and that are worthy to others after financial commitments are made.</p>
                        <Link className="btn btn-link text-dark" to={"/about"}>Learn more about us <i className="fas fa-arrow-right ms-1"></i></Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* =================================
    Agency */}

        {/* =================================
    Services */}
        <div className="pt-4 pb-4 services">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="section-title text-center">
                  {/* <span className="pre-title">We're Good At </span> */}
                  <h2>Our services </h2>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-6 col-lg-4 mb-4 mb-sm-5">
                <div className="feature-info feature-info-style-2 h-100">
                  <div className="feature-info-icon">
                    <i className="flaticon-museum"></i>
                  </div>
                  <div className="feature-info-content">
                    <h6 className="feature-info-title">Issuing House</h6>
                    <p>This involves the process of assisting companies, governments and its agencies to raise money from the investing public. </p>
                    <div className="d-grid">
                      <Link to={"/services/issuing-house"} className="btn btn-primary">Read More</Link>
                    </div>
                  </div>
                  <div className="feature-info-bg" ></div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4 mb-sm-5">
                <div className="feature-info feature-info-style-2 h-100">
                  <div className="feature-info-icon">
                    <i className="flaticon-graph"></i>
                  </div>
                  <div className="feature-info-content">
                    <h6 className="feature-info-title">Stockbroking</h6>
                    <p>We deal in the purchase and sale of securities on behalf of our numerous clients.</p>
                    <div className="d-grid">
                      <Link to={"/services/stockbroking"} className="btn btn-primary">Read More</Link>
                    </div>
                  </div>
                  <div className="feature-info-bg"></div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4 mb-sm-5">
                <div className="feature-info feature-info-style-2 h-100">
                  <div className="feature-info-icon">
                    <i className="flaticon-advice"></i>
                  </div>
                  <div className="feature-info-content">
                    <h6 className="feature-info-title">Financial Advisory</h6>
                    <p>Dynamic Portfolio provides advisory services to meet our clients' needs in the area of corporate restructuring, mergers & acquisition, management -buy- out and privatization of government owned institutions.</p>
                    <div className="d-grid">
                      <Link to={"/services/financial-advisory"} className="btn btn-primary">Read More</Link>
                    </div>
                  </div>
                  <div className="feature-info-bg"></div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4 mb-sm-5">
                <div className="feature-info feature-info-style-2 h-100">
                  <div className="feature-info-icon">
                    <i className="flaticon-briefcase"></i>
                  </div>
                  <div className="feature-info-content">
                    <h6 className="feature-info-title">Portfolio Management</h6>
                    <p>The focus of Dynamic's Portfolio Management Services is to assemble appropriate mix of investment instruments that best meet your requirements in terms of safety and yield. </p>
                    <div className="d-grid">
                      <Link to={"/services/portfolio-management"} className="btn btn-primary">Read More</Link>
                    </div>
                  </div>
                  <div className="feature-info-bg"></div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4 mb-sm-5">
                <div className="feature-info feature-info-style-2 h-100">
                  <div className="feature-info-icon">
                    <i className="flaticon-money-1"></i>
                  </div>
                  <div className="feature-info-content">
                    <h6 className="feature-info-title">Fund Management</h6>
                    <p>Our approach to Fund Management is to structure out a balanced investment in consonance with the intention of the fund and to meet the characteristics of the fund. </p>
                    <div className="d-grid">
                      <Link to={"/services/fund-management"} className="btn btn-primary btn-block">Read More</Link>
                    </div>
                  </div>
                  <div className="feature-info-bg"></div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4 mb-sm-5">
                <div className="feature-info feature-info-style-2 h-100">
                  <div className="feature-info-icon">
                    <i className="flaticon-money-2"></i>
                  </div>
                  <div className="feature-info-content">
                    <h6 className="feature-info-title">Lagos Commodities and Future Exchange (LCFE)</h6>
                    <p>Dynamic Portfolio Ltd is a licenced member of the Lagos Commodities and Future Exchange. </p>
                    <div className="d-grid">
                      <Link to={"/services/lagos-commodities-and-future-exchange"} className="btn btn-primary btn-block">Read More</Link>
                    </div>
                  </div>
                  <div className="feature-info-bg"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* =================================
  Services */}

        {/* <!--=================================
    Counter --> */}
        <div className="position-relative">
            <div className="counter bg-dark">
          <div className="container">
              <div className="row">
                <div className="col-sm-6 col-lg-6 mb-4 mb-lg-0 position-relative">
                  <div className="counter-item">
                    <div className="counter-icon">
                      <i className="flaticon-clock"></i>
                    </div>
                    <div className="counter-content">
                      <span className="timer text-white" data-to="29" data-speed="1000">29</span>
                      <label className="text-white">Years of Experience</label>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-lg-6 mb-4 mb-lg-0 position-relative">
                  <div className="counter-item">
                    <div className="counter-icon">
                      <i className="flaticon-team"></i>
                    </div>
                    <div className="counter-content">
                      <span className="timer text-white" data-to="3796" data-speed="1000">3796</span>
                      <label className="text-white">Happy Clients</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!--=================================
    Counter --> */}

        {/* <!--=================================
  Site Content --> */}
  <div class="bg-light">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="text-left p-4 p-md-5">
            <h4>Get IDIA App</h4>
            <p>Download our IDIA trading app now</p>
            <a class="btn btn-google" target={"_blank"} href="https://play.google.com/store/apps/details?id=com.solutarisllc.Idia" title="Google Play">Google Play</a>
          </div>
          </div>
          <div class="col-md-6">
            <div style={{float: "right"}} class="pb-2 pt-2">
              <img height="300px" src={require("../../dassets/images/idia-app.png")} alt="" />
          </div>
          </div>
        </div>
      </div>
  </div>
  {/* <!--=================================
  Site Content --> */}

        {/* <!--=================================
    Client Logo --> */}
        <section className="pt-3 pb-3">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="owl-carousel our-clients" data-nav-arrow="false" data-items="6" data-md-items="5" data-sm-items="4" data-xs-items="3" data-xx-items="1" data-space="30" data-autoheight="true" data-autospeed="4000">
                  <div className="item">
                    <img className="img-fluid p-3" src={require("../../dassets/images/client/01.png")} alt="" />
                  </div>
                  <div className="item">
                    <img className="img-fluid p-3" src={require("../../dassets/images/client/02.png")} alt="" />
                  </div>
                  <div className="item">
                    <img className="img-fluid p-3" src={require("../../dassets/images/client/03.png")} alt="" />
                  </div>
                  <div className="item">
                    <img className="img-fluid p-3" src={require("../../dassets/images/client/09.png")} alt="" />
                  </div>
                  <div className="item">
                    <img className="img-fluid p-3" src={require("../../dassets/images/client/04.png")} alt="" />
                  </div>
                  <div className="item">
                    <img className="img-fluid p-3" src={require("../../dassets/images/client/05.png")} alt="" />
                  </div>
                  <div className="item">
                    <img className="img-fluid p-3" src={require("../../dassets/images/client/06.png")} alt="" />
                  </div>
                  <div className="item">
                    <img className="img-fluid p-3" src={require("../../dassets/images/client/07.png")} alt="" />
                  </div>
                  <div className="item">
                    <img className="img-fluid p-3" src={require("../../dassets/images/client/08.png")} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!--=================================
    Client Logo --> */}

        {/* <!--=================================
    Latest News --> */}
        {/* <section className="space-pb">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 mb-4 mb-lg-0">
            <div className="section-title">
              <span className="pre-title">Blog & News </span>
              <h2>Fresh finaxo latest news </h2>
            </div>
            <p className="lead mb-0">For those of you who are serious about having more, doing more, giving more and being more, success is achievable with some understanding of what to do, some discipline around planning. </p>
            <div className="mt-4 mt-md-5">Like what you see? <Link to={"#"}><b>See more posts</b></Link> </div>
          </div>
          <div className="col-lg-8">
            <div className="owl-carousel blog-post-style-1" data-nav-arrow="false" data-items="2" data-md-items="2" data-sm-items="2" data-xs-items="2" data-xx-items="1" data-space="30" data-autoheight="true" data-autospeed="6000">
              <div className="item">
                <div className="blog-post">
                  <div className="blog-post-img">
                    <img className="img-fluid" src={require("../../dassets/images/blog/01.jpg")} alt=""/>
                  </div>
                  <div className="blog-post-info">
                    <Link className="blog-post-category" to={"#"}>Finance</Link>
                    <h5 className="blog-post-title"><Link to={"#"}>Tips for hiring best outreach Agency for your Company</Link></h5>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="blog-post">
                  <div className="blog-post-img">
                    <img className="img-fluid" src={require("../../dassets/images/blog/02.jpg")} alt=""/>
                  </div>
                  <div className="blog-post-info">
                    <Link className="blog-post-category" to={"#"}>Jobs</Link>
                    <h5 className="blog-post-title"><Link to={"#"}>How to create and operate a successful Business</Link></h5>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="blog-post">
                  <div className="blog-post-img">
                    <img className="img-fluid" src={require("../../dassets/images/blog/03.jpg")} alt=""/>
                  </div>
                  <div className="blog-post-info">
                    <Link className="blog-post-category" to={"#"}>Marketing</Link>
                    <h5 className="blog-post-title"><Link to={"#"}>6 Apps for Automation Your Work in 2020</Link></h5>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="blog-post">
                  <div className="blog-post-img">
                    <img className="img-fluid" src={require("../../dassets/images/blog/04.jpg")} alt=""/>
                  </div>
                  <div className="blog-post-info">
                    <Link className="blog-post-category" to={"#"}>Operations</Link>
                    <h5 className="blog-post-title"><Link to={"#"}>How to find the best Marketing sites in the UK</Link></h5>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="blog-post">
                  <div className="blog-post-img">
                    <img className="img-fluid" src={require("../../dassets/images/blog/05.jpg")} alt=""/>
                  </div>
                  <div className="blog-post-info">
                    <Link className="blog-post-category" to={"#"}>Marketing</Link>
                    <h5 className="blog-post-title"><Link to={"#"}>Strategies to market new-age businesses</Link></h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> */}
        {/* <!--=================================
    Latest News --> */}
      </>
    );
  }
}

export default Home;